import { sendSpeechRecognitionDataAPI } from 'src/stores/match/apis';

import type { SttSegment } from './SpeechRecognizerManager';

const PERIODIC_SEND_INTERVAL_MS = 5_000;
const BUFFER_FLUSH_THRESHOLD = 30;

/**
 * 매치 중 STT segment를 버퍼링하고 주기적으로 서버에 전송한다.
 * iOS STTDataCollector actor 패턴과 동일:
 * - 5초 간격 또는 버퍼 30개 이상일 때 전송
 * - 전송 실패 시 무시 (fire-and-forget)
 */
export class SttDataCollector {
  private buffer: SttSegment[] = [];

  private timer: ReturnType<typeof setInterval> | null = null;

  private active = false;

  constructor(
    readonly matchId: string,
    readonly languageCode: string
  ) {}

  add(segment: SttSegment): void {
    if (!segment.text.trim()) return;
    this.buffer.push(segment);

    if (this.buffer.length >= BUFFER_FLUSH_THRESHOLD) {
      this.flush();
    }
  }

  startPeriodicSend(): void {
    if (this.active) return;

    this.active = true;
    this.timer = setInterval(() => {
      if (this.active) {
        this.flush();
      }
    }, PERIODIC_SEND_INTERVAL_MS);
  }

  stop(): void {
    this.active = false;
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.flush();
  }

  private flush(): void {
    if (this.buffer.length === 0) return;

    const dataToSend = this.buffer;

    // API 전송 여부와 관계없이 buffer 초기화 (iOS / Android와 동일)
    this.buffer = [];

    sendSpeechRecognitionDataAPI({
      matchId: this.matchId,
      sttData: dataToSend,
      languageCode: this.languageCode,
      apiCallMillis: Date.now(),
    }).catch(() => {
      // API 전송 실패 시 무시 (iOS / Android와 동일)
    });
  }
}
